const HERO_SLIDE_SHOW_COUNT = 9;

export const HERO_IMAGES_SLIDE_SHOW = Array.from(
  { length: HERO_SLIDE_SHOW_COUNT },
  (_, i) => `/events/hero_slide_show/Hero2-${i + 1}.png`
);

export const SUBSCRIBE_TO_EVENTS_TEXT = 'Get event updates';
export const UNSUBSCRIBE_FROM_EVENTS_TEXT = 'Unsubscribe from events';

export const MORE_INFO_TEXT = 'More info';
export const SECURE_YOUR_SPOT_TEXT = 'Secure your spot';
export const SPONSOR_TEXT = 'Sponsor';

export const DESCRIPTION_MAX_LENGTH = 250;

export const ANCHOR_LINKS = [
  {
    name: 'Upcoming',
    hash: 'upcoming',
  },
  {
    name: 'Partner',
  },
  {
    name: 'Speak',
    hash: 'speakers',
  },
];

export const EVENT_RATIO = [
  {
    ratio: '1:15',
    description: 'Events have an speaker-to-attendee ratio of 1:15 or better',
  },
  {
    ratio: '64.7%',
    description: 'of summit attendees are senior decision makers (VP or higher)',
  },
  {
    ratio: '25+',
    description: 'Events in 2025',
  },
];

const MID_SECTION_SLIDE_COUNT = 21;

export const MIDDLE_SLIDE_SHOW_IMAGES = Array.from(
  { length: MID_SECTION_SLIDE_COUNT },
  (_, i) => `/events/mid_section_images/image_${i + 1}.png`
);

export const PAST_SPEAKERS = [
  {
    name: 'Sam Altman',
    title: 'Co-founder & CEO, OpenAI',
    image: 'events/past_speakers/Sam_A.png',
  },
  {
    name: 'Daniela Amodei',
    title: 'President & Co-founder, Anthropic',
    image: 'events/past_speakers/Daniela_A.png',
  },
  {
    name: 'Reid Hoffman',
    title: 'Co-founder, LinkedIn, Co-founder, Inflection AI, Partner, Greylock',
    image: 'events/past_speakers/Reid_H.png',
  },
  {
    name: 'Amrita Ahuja',
    title: 'CFO & COO, Block',
    image: 'events/past_speakers/Amrita_A.png',
  },
  {
    name: 'Elizabeth Stone',
    title: 'CTO, Netflix',
    image: 'events/past_speakers/Elizabeth_S.png',
  },
  {
    name: 'Vinod Khosla',
    title: 'Founder, Khosla Ventures',
    image: 'events/past_speakers/Vinod_K.png',
  },
  {
    name: 'Paris Hilton',
    title: 'CEO, 11:11 Media',
    image: 'events/past_speakers/Paris_H.png',
  },
  {
    name: 'Patrick Collison',
    title: 'CEO & Co-founder, Stripe',
    image: 'events/past_speakers/Patrick_C.png',
  },
  {
    name: 'Philippe Laffont',
    title: 'Founder & Chief Investment Officer, Coatue',
    image: 'events/past_speakers/Philip_L.png',
  },
  {
    name: 'Dara Treseder',
    title: 'CMO, Autodesk',
    image: 'events/past_speakers/Dara_T.png',
  },
  {
    name: 'Evan Spiegel',
    title: 'Co-founder & CEO, Snap',
    image: 'events/past_speakers/Evan_S.png',
  },
  {
    name: 'Chelsea Clinton',
    title: 'Vice Chair, Clinton Foundation & Co-founder, Metrodora Ventures',
    image: 'events/past_speakers/Chelsea _Clinton.png',
  },
  {
    name: 'Shou Zi Chew',
    title: 'CEO, TikTok',
    image: 'events/past_speakers/Shou_Z.png',
  },
  {
    name: 'Anjali Sud',
    title: 'CEO, Tubi',
    image: 'events/past_speakers/Anjali_Sud.png',
  },
  {
    name: 'Esi Eggleston Bracey',
    title: 'Chief Growth & Marketing Officer, Unilever',
    image: 'events/past_speakers/Esi_Bracey.png',
  },
  {
    name: 'Joe Tsai',
    title: 'Co-founder, Alibaba Group',
    image: 'events/past_speakers/Joe_T.png',
  },
];

export const MOMENT_THAT_MATTERS_VIDEO_URL =
  'https://tii.imgix.net/global/events/Events_Mashup_NEC.mp4';

export const MOMENT_THAT_MATTERS_POSTER_IMAGE_URL =
  'https://tii.imgix.net/global/events/video_img_post.png';

export const PAST_PARTNERS_LOGOS = [
  { path: 'events/partner_logos/meta.png', alt: 'Meta' },
  { path: 'events/partner_logos/amazon.png', alt: 'Amazon' },
  { path: 'events/partner_logos/nyse.png', alt: 'New York Stock Exchange' },
  { path: 'events/partner_logos/pwc.png', alt: 'PwC' },
];

export const TESTIMONIAL_DATA = [
  {
    name: 'Andrew Tan',
    title:
      'Founding Partner at Humans, Creator of TLDR AI Newsletter, Founder & CEO of Nova (acquired)',
    quote:
      'The Information’s AI Summit brought together the perfect mix of industry leaders, technical innovators, and forward-thinking investors for meaningful conversations about the future of AI. The speakers delivered exceptional insights that went beyond surface-level discussions, offering practical perspectives on navigating the AI landscape. The networking opportunities were invaluable - I made several connections that have already led to exciting collaborations.”',
  },
  {
    name: 'Josh Zimmerman',
    title: 'CEO, Founder & Coach',
    quote:
      'Talk about a powerhouse lineup. But what makes The Information summits so unique is that they are not just panels from industry and thought leaders, the moderators are journalists asking tough questions live. Can it be a bit of an uncomfortable moment? Sure at first, but what you get to witness is a true look into what good journalism looks like and a lot of the time learn something before anyone else in the industry knows about it.”',
  },
];

export const SPEAKER_FORM_URL = 'https://forms.gle/ZsDzfth5JbQ9b4FH7';

export const SPONSORSHIPS_EMAIL_ADDRESS = 'sponsorships@theinformation.com';
export const EVENTS_EMAIL_ADDRESS = 'events@theinformation.com';
